

















































































































































































































































































































































import { Component, Provide, Vue } from "vue-property-decorator";
import DEmpty from "../base/DEmpty.vue";
import { API_BIS_REPORT_CUSTOMIZED, API_BIS_REPORT_CUSTOMIZED_WITH_ID, API_BIS_REPORT_MODEL, API_BIS_REPORT_STAT } from "@/configs/Apis";
import { showConfirm, showSuccess } from "@/utils/UI";
import { ReportResult, ChartType } from "@/app-data/report/entities/reportEntity";
import { SYSTEM_REPORT_TREE } from "@/app-data/report/models";
import { MONITOR_PROJECT_ID } from "@/app-data/monitor/monitor";
import ReportChart from "./ReportChart.vue";
import ReportTable from "./ReportTable.vue";
import ReportFilter from "./ReportFilter.vue";
import AdvSearch from "@/views/base/AdvSearch.vue";

import * as charts from "@/app-data/report/charts";
import StatisticsPreview from "@/views/report/StatisticsPreview.vue";

@Component({ components: { StatisticsPreview, DEmpty, ReportChart, ReportTable, ReportFilter, AdvSearch } })
export default class ReportIndex extends Vue {
  reportTreeData: Array<any> = [];

  defaultProps: any = {
    children: "children",
    label: "label"
  };

  expandedKeys: Array<number> = [];
  checkedKeys: Array<number> = [];
  treeStyles: any = {};

  currentNode: any = null;

  currentChartOption: any = {};
  currentDefinition: any = {};
  currentReportTitle = "";
  currentDatas: ReportResult = {
    colCount: 0,
    colDimNodes: [],
    dataValues: [],
    rowColIndexes: [],
    rowCount: 0,
    rowDimNodes: [],
    totalIndex: 0
  };

  updateDataByFilter = false;

  showReportEditWin = false;

  currentReport: any = {};
  initReportEntity: any = {
    id: 0,
    name: "",
    rowDim1Name: "",
    rowDim1Limit: 20,
    rowDim1Total: true,
    rowDim1Sub: true,
    rowDim2Name: "",
    rowDim2Limit: 20,
    rowDim2Total: true,
    rowDim2Sub: true,
    colDim1Name: "",
    colDim1Limit: 20,
    colDim1Total: true,
    colDim1Sub: true,
    measure1Name: "count",
    measure1MinValue: 0,
    chartType: "",
    chartTitle: "",
    chartSubTitle: "",
    xaxisTitle: "",
    yaxisTitle: "",
    hideTitle: false,
    hideAxisTitle: true,
    hideLabel: false,
    hideLegend: false,
    hideToolbox: false,
    condition: JSON.stringify({ items: [], relation: "" })
  };

  dimGroups: Array<any> = [];

  allMeasures: Array<any> = [];

  customizedReports: any = {};

  reportEditStep = 0;

  helpText: string = "a. 1个行维度支持: 折线图/柱状图/饼图<br/>" +
    "b. 1个行维度 + 1个列维度, 支持: 折线图/柱状图/气泡图/热力图<br/>" +
    "c. 2个行维度 + 1个列维度, 支持: 气泡图<br/>" +
    "d. 2个行维度, 支持: 折线图/柱状图";

  colseEditReport() {
    this.reportEditStep = 0;
    this.showReportEditWin = false;
  }

  editReportPreStep() {
    if (this.reportEditStep === 1) {
      this.reportEditStep = 0;
    } else if (this.reportEditStep === 2) {
      this.reportEditStep = 1;
    }
  }

  editReportNextStep() {
    if (this.reportEditStep === 0) {
      (this.$refs.reportForm as any).validate((isValid: boolean) => {
        if (!isValid) {
          return;
        }
        this.reportEditStep = 1;
      });
    } else if (this.reportEditStep === 1) {
      (this.$refs.reportChartForm as any).validate((isValid: boolean) => {
        if (!isValid) {
          return;
        }
        this.reportEditStep = 2;
      });
    }
  }

  @Provide()
  get projectId() {
    if (this.$route.name === "MonitorIndex") {
      return MONITOR_PROJECT_ID;
    }

    const pInfo: any = this.$store.state.project.info || {};
    return this.$route.query.id || pInfo.id || 0;
  }

  onReportNameChange() {
    if (this.currentReport.chartTitle === "") {
      this.currentReport.chartTitle = this.currentReport.name;
    }
  }

  get chartTypes() {
    // a. 1个行维度支持: 折线图/柱状图/饼图<br/>
    // b. 1个行维度 + 1个列维度, 支持: 折线图/柱状图/气泡图/热力图<br/>
    // c. 2个行维度 + 1个列维度, 支持: 气泡图<br/>
    // d. 2个行维度, 支持: 折线图/柱状图

    let lineDisabled = true;
    let barDisabled = true;
    let pieDisabled = true;
    let matrixPieDisabled = true;
    let heatMapDisabled = true;

    if (this.currentReport.rowDim1Name !== "") {
      if (this.currentReport.rowDim2Name !== "") {
        if (this.currentReport.colDim1Name !== "") {
          matrixPieDisabled = false;
        } else {
          lineDisabled = false;
          barDisabled = false;
        }
      } else {
        if (this.currentReport.colDim1Name !== "") {
          lineDisabled = false;
          barDisabled = false;
          matrixPieDisabled = false;
          heatMapDisabled = false;
        } else {
          lineDisabled = false;
          barDisabled = false;
          pieDisabled = false;
        }
      }
    }

    return [{
      value: "LINE",
      label: "折线图",
      disabled: lineDisabled
    }, {
      value: "BAR",
      label: "柱状图",
      disabled: barDisabled
    }, {
      value: "PIE",
      label: "饼图",
      disabled: pieDisabled
    }, {
      value: "MATRIXPIE",
      label: "气泡图",
      disabled: matrixPieDisabled
    }, {
      value: "HEATMAP",
      label: "热力图",
      disabled: heatMapDisabled
    }];
  }

  created() {
    this.initReportTree();
  }

  initReportTree(id?: number) {
    const projectId = this.projectId;
    this.$http.get<any>({ url: API_BIS_REPORT_CUSTOMIZED, path: { projectId } }).then((datas) => {
      const customizedReport: any = {
        id: 1000,
        label: "自定义分析",
        children: []
      };

      for (let i = 0; i < datas.length; i++) {
        const rpt = datas[i];
        let chart;
        if (!Object.prototype.hasOwnProperty.call(rpt, "chartOption")) {
          continue;
        }
        const chartOption: any = JSON.parse(rpt.chartOption);
        const definition: any = JSON.parse(rpt.definition);
        if (definition.measures.length > 1) {
          definition.measures = [definition.measures[0]];
        }

        if (definition.rowDims.length === 1) {
          if (definition.colDims.length === 0) {
            // a. 1个行维度支持: 折线图/柱状图/饼图<br/>
            if (chartOption.chartType === "LINE") {
              chart = charts.lineAndBar;
              chartOption.chartType = ChartType.LINE;
            } else if (chartOption.chartType === "BAR") {
              chart = charts.lineAndBar;
              chartOption.chartType = ChartType.BAR;
            } else if (chartOption.chartType === "PIE") {
              chart = charts.pie;
              chartOption.chartType = ChartType.PIE;
            } else {
              continue;
            }
          } else if (definition.colDims.length === 1) {
            // b. 1个行维度 + 1个列维度, 支持: 折线图/柱状图/气泡图/热力图<br/>
            if (chartOption.chartType === "LINE") {
              chart = charts.lineAndBar2D;
              chartOption.chartType = ChartType.LINE;
            } else if (chartOption.chartType === "BAR") {
              chart = charts.lineAndBar2D;
              chartOption.chartType = ChartType.BAR;
            } else if (chartOption.chartType === "MATRIXPIE") {
              chart = charts.matrixPie2D;
              chartOption.chartType = ChartType.MATRIXPIE;
            } else if (chartOption.chartType === "HEATMAP") {
              chart = charts.headMap2D;
              chartOption.chartType = ChartType.HEATMAP;
            } else {
              continue;
            }
          }
        } else if (definition.rowDims.length === 2) {
          if (definition.colDims.length === 1) {
            // c. 2个行维度 + 1个列维度, 支持: 气泡图<br/>
            if (chartOption.chartType === "MATRIXPIE") {
              chart = charts.matrixPie3D;
              chartOption.chartType = ChartType.MATRIXPIE;
            } else {
              continue;
            }
          } else if (definition.colDims.length === 0) {
            // d. 2个行维度, 支持: 折线图/柱状图
            if (chartOption.chartType === "LINE") {
              chart = charts.lineAndBar2DFor2RowDim;
              chartOption.chartType = ChartType.LINE;
            } else if (chartOption.chartType === "BAR") {
              chart = charts.lineAndBar2DFor2RowDim;
              chartOption.chartType = ChartType.BAR;
            } else {
              continue;
            }
          }
        } else {
          continue;
        }

        const rptEntity = {
          id: rpt.id,
          label: rpt.name,
          chart: chart,
          definition: definition,
          chartTypeStr: chartOption.chartType.toString(),
          chartOption: chartOption
        };
        customizedReport.children.push(rptEntity);

        this.customizedReports[rpt.id] = rptEntity;
      }

      this.reportTreeData = SYSTEM_REPORT_TREE;// .concat([customizedReport]);

      let node: any = {};
      let checkedId = id;
      if (checkedId) {
        if (checkedId === 0) {
          checkedId = this.reportTreeData[0].children[0].id;
          node = this.reportTreeData[0].children[0];
        } else if (checkedId === 1000) {
          node = customizedReport;
        } else {
          node = this.customizedReports[checkedId];
        }
        if (checkedId) {
          this.expandedKeys = [checkedId >= 1000 ? 1000 : parseInt("" + (checkedId / 20))];
          this.checkedKeys = [checkedId];
        }
        this.handleNodeClick(node);
      } else {
        this.currentNode = null;
      }
    });

    this.$http.get<any>({ url: API_BIS_REPORT_MODEL, path: { projectId } }).then((model) => {
      this.dimGroups = model.dimensions;
      for (let i = 0; i < this.dimGroups.length; i++) {
        for (let j = 0; j < this.dimGroups[i].dims.length; j++) {
          this.dimGroups[i].dims[j].rname = this.dimGroups[i].dims[j].name;
          if (this.dimGroups[i].dims[j].dateUnit) {
            if (this.dimGroups[i].dims[j].dateUnit === "YEAR") {
              this.dimGroups[i].dims[j].rname = this.dimGroups[i].dims[j].rname + "__y";
            } else if (this.dimGroups[i].dims[j].dateUnit === "MONTH") {
              this.dimGroups[i].dims[j].rname = this.dimGroups[i].dims[j].rname + "__m";
            }
          }
        }
      }
      this.allMeasures = model.measures;
    });
  }

  handleNodeClick(node: any) {
    if (node.id === null) {
      this.currentNode = null;
      return;
    }
    this.treeStyles = {};
    this.treeStyles[node.id] = {
      color: "#6775e0"
    };

    if (!node || !node.definition) {
      return;
    }

    const projectId = this.projectId;
    this.$http.post<ReportResult>({ url: API_BIS_REPORT_STAT, path: { projectId } }, node.definition).then((datas) => {
      this.updateDataByFilter = false;
      this.currentNode = node;

      this.$nextTick().then(() => {
        this.currentDefinition = node.definition;
        this.currentDatas = datas;
        this.currentReportTitle = node.label;
        this.renderChart();
      });
    });
  }

  private renderChart() {
    this.currentChartOption = this.currentNode.chart(this.currentDefinition, this.currentNode.chartOption, this.currentDatas);
  }

  reFilter(datas: ReportResult) {
    this.updateDataByFilter = true;
    this.currentDatas = datas;
    this.renderChart();
  }

  switchXY() {
    const newDefinition = JSON.parse(JSON.stringify(this.currentDefinition));

    if (this.currentNode.id === 5) { // lifeCycle
      newDefinition.measures = [this.currentDefinition.measures[1], this.currentDefinition.measures[0]];
    } else if (this.currentDefinition.rowDims && this.currentDefinition.rowDims.length === 2 &&
      (!this.currentDefinition.colDims || this.currentDefinition.colDims.length === 0)) {
      newDefinition.rowDims = [this.currentDefinition.rowDims[1], this.currentDefinition.rowDims[0]];
      newDefinition.colDims = [];
    } else if (this.currentDefinition.rowDims && this.currentDefinition.rowDims.length === 1 &&
      this.currentDefinition.colDims && this.currentDefinition.colDims.length === 1) {
      newDefinition.rowDims = [this.currentDefinition.colDims[0]];
      newDefinition.colDims = [this.currentDefinition.rowDims[0]];
    } else {
      return;
    }

    const projectId = this.projectId;
    this.$http.post<ReportResult>({ url: API_BIS_REPORT_STAT, path: { projectId } }, newDefinition).then((datas) => {
      this.updateDataByFilter = false;

      this.currentDefinition = newDefinition;
      this.currentDatas = datas;

      this.renderChart();
    });
  }

  addReport() {
    this.currentReport = JSON.parse(JSON.stringify(this.initReportEntity));
    this.showReportEditWin = true;
  }

  private getRealDimName(dim: any) {
    if (dim.dateUnit) {
      if (dim.dateUnit === "YEAR") {
        return dim.name + "__y";
      }
      if (dim.dateUnit === "MONTH") {
        return dim.name + "__m";
      }
    }
    return dim.name;
  }

  editReport(node: any, data: any) {
    const rptEntity = this.customizedReports[node.id];
    const rdim1 = rptEntity.definition.rowDims && rptEntity.definition.rowDims[0] ? rptEntity.definition.rowDims[0] : false;
    const rdim2 = rptEntity.definition.rowDims && rptEntity.definition.rowDims[1] ? rptEntity.definition.rowDims[1] : false;
    const cdim1 = rptEntity.definition.colDims && rptEntity.definition.colDims[0] ? rptEntity.definition.colDims[0] : false;
    const measure1 = rptEntity.definition.measures && rptEntity.definition.measures[0] ? rptEntity.definition.measures[0] : false;
    const chartOption = rptEntity.chartOption;
    this.currentReport = {
      id: node.id,
      name: rptEntity.label,
      rowDim1Name: rdim1 ? this.getRealDimName(rdim1) : "",
      rowDim1Limit: rdim1 ? rdim1.limit : 20,
      rowDim1Total: rdim1 ? rdim1.needTotal : true,
      rowDim1Sub: rdim1 ? !rdim1.self : true,
      rowDim2Name: rdim2 ? this.getRealDimName(rdim2) : "",
      rowDim2Limit: rdim2 ? rdim2.limit : 20,
      rowDim2Total: rdim2 ? rdim2.needTotal : true,
      rowDim2Sub: rdim1 ? !rdim2.self : true,
      colDim1Name: cdim1 ? this.getRealDimName(cdim1) : "",
      colDim1Limit: cdim1 ? cdim1.limit : 20,
      colDim1Total: cdim1 ? cdim1.needTotal : true,
      colDim1Sub: cdim1 ? !cdim1.self : true,
      measure1Name: measure1 ? measure1.name : "count",
      measure1MinValue: measure1 ? measure1.minValue : 0,
      chartType: chartOption ? ChartType[chartOption.chartType] : "",
      chartTitle: chartOption ? chartOption.title : "",
      chartSubTitle: chartOption ? chartOption.subTitle : "",
      xaxisTitle: chartOption ? chartOption.xaxisTitle : "",
      yaxisTitle: chartOption ? chartOption.yaxisTitle : "",
      hideTitle: chartOption ? chartOption.hideTitle : false,
      hideAxisTitle: chartOption ? chartOption.hideAxisTitle : true,
      hideLabel: chartOption ? chartOption.hideLabel : false,
      hideLegend: chartOption ? chartOption.hideLegend : false,
      hideToolbox: chartOption ? chartOption.hideToolbox : false,
      condition: JSON.stringify(rptEntity.definition.condition ? rptEntity.definition.condition : { items: [], relation: "" })
    };
    this.showReportEditWin = true;
  }

  deleteReport(node: any, data: any) {
    const projectId = this.projectId;
    showConfirm("确定删除报表: " + data.label + "?").then(() => {
      this.$http.delete({ url: API_BIS_REPORT_CUSTOMIZED_WITH_ID, path: { projectId: projectId, id: data.id } }, data.id).then(() => {
        showSuccess("删除成功");
        this.initReportTree(1000);
      });
    });
  }

  private getDimDef(name: string) {
    for (let i = 0; i < this.dimGroups.length; i++) {
      const dims = this.dimGroups[i].dims;
      for (let j = 0; j < dims.length; j++) {
        if (dims[j].rname === name) {
          return JSON.parse(JSON.stringify(dims[j]));
        }
      }
    }
    return null;
  }

  private getMeasureDef(name: string) {
    for (let j = 0; j < this.allMeasures.length; j++) {
      if (this.allMeasures[j].name === name) {
        return JSON.parse(JSON.stringify(this.allMeasures[j]));
      }
    }
    return null;
  }

  saveReport() {
    (this.$refs.reportForm as any).validate((isValid: boolean) => {
      if (!isValid) {
        return;
      }

      (this.$refs.reportChartForm as any).validate((isValid: boolean) => {
        if (!isValid) {
          return;
        }
        this.saveReport2();
      });
    });
  }

  saveReport2() {
    const projectId = this.projectId;

    const rowDims: Array<any> = [];
    if (this.currentReport.rowDim1Name !== "") {
      const dim: any = this.getDimDef(this.currentReport.rowDim1Name);
      if (dim) {
        delete dim.rname;
        dim.limit = this.currentReport.rowDim1Limit;
        dim.needTotal = this.currentReport.rowDim1Total;

        if (dim.name.indexOf("category") === 0) {
          dim.self = !this.currentReport.rowDim1Sub;
        }

        rowDims.push(dim);
      }
    }

    if (this.currentReport.rowDim2Name !== "") {
      const dim: any = this.getDimDef(this.currentReport.rowDim2Name);
      if (dim) {
        delete dim.rname;
        dim.limit = this.currentReport.rowDim2Limit;
        dim.needTotal = this.currentReport.rowDim2Total;

        if (dim.name.indexOf("category") === 0) {
          dim.self = !this.currentReport.rowDim2Sub;
        }

        rowDims.push(dim);
      }
    }

    const colDims: Array<any> = [];
    if (this.currentReport.colDim1Name !== "") {
      const dim: any = this.getDimDef(this.currentReport.colDim1Name);
      if (dim) {
        delete dim.rname;
        dim.limit = this.currentReport.colDim1Limit;
        dim.needTotal = this.currentReport.colDim1Total;

        if (dim.name.indexOf("category") === 0) {
          dim.self = !this.currentReport.colDim1Sub;
        }

        colDims.push(dim);
      }
    }

    const measures: Array<any> = [];
    if (this.currentReport.measure1Name !== "") {
      const measure: any = this.getMeasureDef(this.currentReport.measure1Name);
      if (measure) {
        measure.minValue = this.currentReport.measure1MinValue;
        measures.push(measure);
      }
    }

    const adv = this.$refs.advt as any;
    const definition = {
      rowDims: rowDims,
      colDims: colDims,
      measures: measures,
      condition: JSON.parse(adv.getSearchData()) || { items: [], relation: "" }
    };

    const chartOption = {
      chartType: this.currentReport.chartType,
      title: this.currentReport.chartTitle,
      subTitle: this.currentReport.chartSubTitle,
      xaxisTitle: this.currentReport.xaxisTitle,
      yaxisTitle: this.currentReport.yaxisTitle,
      hideTitle: this.currentReport.hideTitle,
      hideAxisTitle: this.currentReport.hideAxisTitle,
      hideLabel: this.currentReport.hideLabel,
      hideLegend: this.currentReport.hideLegend,
      hideToolbox: this.currentReport.hideToolbox
    };

    const rpt = {
      name: this.currentReport.name,
      definition: JSON.stringify(definition),
      chartOption: JSON.stringify(chartOption)
    };
    if (this.currentReport.id > 0) {
      this.$http.put({ url: API_BIS_REPORT_CUSTOMIZED_WITH_ID, path: { projectId: projectId, id: this.currentReport.id } }, rpt).then(() => {
        showSuccess("保存成功");
        this.saveReportCallback(this.currentReport.id);
      });
    } else {
      this.$http.post<number>({ url: API_BIS_REPORT_CUSTOMIZED, path: { projectId: projectId } }, rpt).then((id) => {
        showSuccess("保存成功");
        this.saveReportCallback(id);
      });
    }
  }

  saveReportCallback(id: number) {
    this.initReportTree(id);
    this.colseEditReport();
  }

  get reportRules() {
    const validateRepeatDim = (rule: any, value: any, callback: any) => {
      const repeated = (this.currentReport.rowDim1Name !== "" && this.currentReport.rowDim2Name !== "" &&
        this.currentReport.rowDim1Name === this.currentReport.rowDim2Name) ||
        (this.currentReport.rowDim1Name !== "" && this.currentReport.colDim1Name !== "" &&
          this.currentReport.rowDim1Name === this.currentReport.colDim1Name) ||
        (this.currentReport.rowDim2Name !== "" && this.currentReport.colDim1Name !== "" &&
          this.currentReport.rowDim2Name === this.currentReport.colDim1Name);
      if (repeated) {
        callback(new Error("维度不能重复"));
      } else {
        callback();
      }
    };
    const validateChartType = (rule: any, value: any, callback: any) => {
      for (let i = 0; i < this.chartTypes.length; i++) {
        if (this.chartTypes[i].value === this.currentReport.chartType && this.chartTypes[i].disabled) {
          this.currentReport.chartType = "";
          callback(new Error("图表类型不合法"));
          return;
        }
      }
      callback();
    };
    return {
      name: [
        { required: true, message: "请输入名称", trigger: "blur" }
      ],
      rowDim1Name: [
        { required: true, message: "请选择", trigger: "change" },
        { validator: validateRepeatDim, trigger: "change" }
      ],
      rowDim2Name: [
        { validator: validateRepeatDim, trigger: "change" }
      ],
      colDim1Name: [
        { validator: validateRepeatDim, trigger: "change" }
      ],
      measure1Name: [
        { required: true, message: "请选择", trigger: "change" }
      ],
      chartType: [
        { required: true, message: "请选择", trigger: "change" },
        { validator: validateChartType, trigger: "change" }
      ]
    };
  }

  navToList() {
    this.$router.replace({ path: "/patentlist", query: { id: this.projectId } });
  }
}

